import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ClausesService } from '@services/clauses.service';
import { RequirementService } from '@services/requirement.service';
import { SendingIdService } from '@services/sending-id.service';
import { TemplateService } from '@services/template.service';
import { UsersService } from '@services/users.service';

export interface Options {
  multiple: boolean;
  width: string;
  tags: boolean;
}

@Component({
    selector: 'app-document-template',
    templateUrl: './document-template.component.html',
    styleUrls: ['./document-template.component.scss'],
    standalone: false
})
export class DocumentTemplateComponent implements OnInit {

  @Input() service: string;
  @Input() typeId: string;
  @Input() requirementId: string;
  @Output() insertTemplate = new EventEmitter<boolean>();

  modelSelect: number;
  clauses: any = [];
  customs: any = [];
  templates: Array<any>;
  public 
  documentForm: FormGroup;
  bloqk : boolean = true;
  generate : boolean = false;
  message : string = '';

  constructor(private activatedRoute: ActivatedRoute,
    public activeModal: NgbActiveModal,
    private _clausesService: ClausesService,
    private _templateService: TemplateService,
    private fb: FormBuilder,
    ) {
      this.documentForm = this.fb.group({
        templateid: [null, Validators.required],
        itemcustoms: this.fb.array([]),
        itemclauses: this.fb.array([]),
        requirementid: [null, Validators.required],
    });
     }

  ngOnInit() {
    this.getTemplates();
  }



  getTemplates() {
    this._templateService.getTemplates(this.requirementId).subscribe(resp => {
      this.templates = resp['result'];
    })
  }

  getCustom($event) {
    this._templateService.getCustomTemplates($event,this.requirementId).subscribe(resp => {
      this.itemcustoms.clear()
      this.customs = resp['result'];
      this.cargaCustom(resp['result']);
      this.bloqk = false;
      if(resp['result'].length > 0){
        this.message = '';
      }
    })
  }

  getClauses($event) {
    this._clausesService.getClausesRequitement(this.requirementId,$event).subscribe(resp => {
      this.itemclauses.clear();
      this.clauses = resp['result'];
      this.cargaClauses(resp['result']);
      this.bloqk = false;
      if(resp['result'].length > 0){
        this.bloqk = false;
        this.message = '';
      }
    })
  }

  cargaCustom(data){
    data.forEach(item => {
      let gg = this.fb.group({
        id: item.id,
        name: item.name,
        value: item.value,
        fieldtype:item.fieldtype
      });
      this.itemcustoms.push(gg);
    });
  }

  cargaClauses(data){
    data.forEach(item => {
      let gg = this.fb.group({
        id: item.id,
        name: item.name,
        value: item.value
      });
      this.itemclauses.push(gg);
    });
  }

  onChange(formDirective: FormGroupDirective,$event){
    if($event){
      // Con bindValue="id", $event debería ser el ID directamente
      // Pero por si acaso, verificamos si es un objeto y extraemos el ID
      let templateId = $event;
      if (typeof $event === 'object' && $event !== null) {
        templateId = $event.id || $event;
      }
      // También podemos obtener el valor del formControl como respaldo
      const formValue = this.documentForm.get('templateid')?.value;
      if (formValue && !templateId) {
        templateId = formValue;
      }
      if (templateId) {
        this.getClauses(templateId);
        this.getCustom(templateId);
      }
    }
  }

  initData($event):void {
    this.getClauses($event);
    this.getCustom($event);
  }


  closeModal() {
    this.activeModal.close('Modal Closed');
  }

  onCheckboxChange(e,index) {
    let item = this.findId(this.itemclauses.value, index);
    this.itemclauses.controls[item[0]].patchValue({
      id: item[1].id,
      name: item[1].name,
      value: e.target.checked
    });
  }

  get itemcustoms(): FormArray {
    return this.documentForm.get('itemcustoms') as FormArray;
  }
  get itemclauses(): FormArray {
    return this.documentForm.get('itemclauses') as FormArray;
  }

  findId = (array, id) => {
    let indice = array.findIndex(item => item.id === id);
    let found = array.find(a => a.id == id);
    return [indice,found];
  }

  clearFormArray = (formArray: FormArray) => {
    formArray = this.fb.array([]);
  }

  onSubmit(formDirective: FormGroupDirective){
    this.documentForm.patchValue({
      requirementid: this.requirementId
    });
    this.bloqk = true;
    this.generate = true;
    this._templateService.createClause(this.documentForm.value).subscribe(resp => {
      if(resp['result']){
        this.activeModal.dismiss();
				this.insertTemplate.emit(true);
        window.open(resp['result'].url, '_blank');
      }else if(resp['error']){
        console.log('error')
      }
      this.bloqk = false;
      this.generate = false;
    })
  }

}
